<hb-modal-dialog heading="Apply Filters" [showFooter]="true" id="objectDrawerFilterDialog" (okClicked)="okClicked()">
  <div content>
    <div class="row">
      <hb-dynamic-details *ngIf="controls && controls.length > 0" class="col-12" [controls]="controls" [trackDirtyEvent]="false"></hb-dynamic-details>
    </div>
  </div>
</hb-modal-dialog>
